import {Injectable} from "@angular/core";
import {Observable, Subject, Subscriber} from "rxjs";
import {CookieService} from "ngx-cookie-service";

enum AccessCookieValues {
  yes = "yes",
  no = "no",
}

@Injectable()
export class CookiePolicyModalService {
  private warningPopupResultSubscriber$: Subscriber<void> = null;
  private readonly _checkedCookieName = "_ACCESS_COOKIE_CHECKED";
  private readonly _checkedCookieExpiresDays = 180;
  private readonly _open$: Subject<void> = new Subject<void>();

  get accessCookie(): string {
    return this.cookieService.get(this._checkedCookieName);
  }

  constructor(private cookieService: CookieService) {}

  verify(): void {
    const cookieEnabled = navigator.cookieEnabled;

    if (cookieEnabled && (!this.accessCookie || this.accessCookie !== AccessCookieValues.yes)) {
      this.setCheckAccessCookie(AccessCookieValues.yes, this._checkedCookieExpiresDays);
    }

    this.warningPopupResultSubscriber$.complete();
    this.warningPopupResultSubscriber$ = null;
  }

  startDialog$(): Observable<void> {
    return new Observable<void>((subscriber) => {
      this.warningPopupResultSubscriber$ = subscriber;

      this.openWarningDialog();
    });
  }

  open$(): Observable<void> {
    return this._open$.asObservable();
  }

  isCookieAccessChecked(): boolean {
    return this.accessCookie === AccessCookieValues.yes;
  }

  private setCheckAccessCookie(value: AccessCookieValues, expires) {
    this.cookieService.set(this._checkedCookieName, value, expires);
  }

  private openWarningDialog(): void {
    this._open$.next();
  }
}
